module.exports = __webpack_public_path__ + "img/registerimage2.cf375b08.png";